var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFanFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fan_ON_Frame2",
    "data-name": "Fan ON_Frame2",
    d: "M10.355,15.192a2.006,2.006,0,0,0,.02-2.227L8.886,10.418a1.735,1.735,0,0,0-.35-.549,1.393,1.393,0,0,0,.45-.31,1.523,1.523,0,0,0,.34-.639,1.986,1.986,0,0,0,.48.35l2.349,1.648a1.7,1.7,0,0,0,2.089.03,2.869,2.869,0,0,0,.51-.489,4.878,4.878,0,0,0,1.2-2.4,1.9,1.9,0,0,0-.21-1.5.83.83,0,0,0-.61-.31,9.041,9.041,0,0,0-5.3,1.508,1.775,1.775,0,0,0-.49.34,1.447,1.447,0,0,0-.34-.689A.01.01,0,0,0,9,7.4a1.488,1.488,0,0,0-.47-.33,2.051,2.051,0,0,0,.29-.469L10.365,4.1a2,2,0,0,0,.02-2.227,3.471,3.471,0,0,0-.45-.539A4.485,4.485,0,0,0,7.686.05a1.593,1.593,0,0,0-1.4.23.906.906,0,0,0-.3.649A10.679,10.679,0,0,0,7.406,6.582a2.534,2.534,0,0,0,.27.449,1.3,1.3,0,0,0-.67.36,1.476,1.476,0,0,0-.35.679,1.844,1.844,0,0,0-.47-.34L3.838,6.083a1.712,1.712,0,0,0-2.089-.02,3.146,3.146,0,0,0-.5.479,4.878,4.878,0,0,0-1.2,2.4,1.9,1.9,0,0,0,.21,1.5.83.83,0,0,0,.61.31,9.041,9.041,0,0,0,5.3-1.508,1.94,1.94,0,0,0,.49-.35,1.488,1.488,0,0,0,.33.649.01.01,0,0,0,.01.01,1.372,1.372,0,0,0,.77.4,2.281,2.281,0,0,0-.29.469,10.586,10.586,0,0,0-1.539,5.623.928.928,0,0,0,.28.659,1.642,1.642,0,0,0,1.4.26,4.406,4.406,0,0,0,2.269-1.219C10.065,15.542,10.235,15.352,10.355,15.192Z",
    transform: "translate(-0.001 0.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanFrame2);
export default __webpack_public_path__ + "static/media/fan_frame2.25f82c064744b03aa8a05ad5a2a75c8c.svg";
export { ForwardRef as ReactComponent };